import React from "react";
import BroadcastPanelView from "./view";
import { noop } from "@client/shared/constants";

const BroadcastPanel = ({
  broadcastTitle = "",
  callerIdName = "",
  callerIdNumber = "",
  overrideCallerId = false,
  phoneNumberList = [],
  errors = {},
  handleChange = noop,
}) => {
  return (
    <BroadcastPanelView
      broadcastTitle={broadcastTitle}
      overrideCallerId={overrideCallerId}
      callerIdName={callerIdName}
      errors={errors}
      callerIdNumber={callerIdNumber}
      phoneNumberList={(phoneNumberList || [])}
      handleChange={handleChange}
    />
  );
};

export default BroadcastPanel;
